/**
 * 前景与展望
 * Created at 2021-10-08 11:35
 * @author teapot
 */
import "./index.css";

import { Image } from "antd";
import { useEffect } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { RootState } from "../../app/store";
import Config from "../../config";
import { detailsAsync } from "../../store/AboutStore";
import { setDetails } from "../../store/HomeStore";
import Oladdress from "./address";
import { locals } from "../../i18n";
import outlookhk from "./image/outlookhk.png";
import outlookcn from "./image/outlookcn.png";
import yjPc from "./image/yjPc.jpg";
const Outlook = () => {
  const location = useLocation<any>();
  const history = useHistory();
  const { id } = useParams<any>();
  const { detailsContent, detailsImgs, detailsContent_m } = useAppSelector(
    (state: RootState) => state.home
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (location.state === undefined) {
      let state = JSON.parse(window.atob(id));
      location.state = state;
    }
    dispatch(setDetails());

    if (
      location.state &&
      !(location.state.uuid && location.state.url && location.state.methods)
    ) {
      history.goBack();
      return;
    }

    if (id && !location.state) {
      let state = JSON.parse(window.atob(id));
      dispatch(
        detailsAsync({
          url: state.url,
          uuid: state.uuid,
          methods: state.methods,
        })
      );
      return;
    }

    dispatch(
      detailsAsync({
        url: location.state?.url,
        uuid: location.state?.uuid,
        methods: location.state?.methods,
        // bottom: location.state?.bottom,
      })
    );
  }, [dispatch, history, location.state, id, location]);
  // console.log(detailsContent);

  const content = () => {
    if (location.state) {
      return (
        <div>
          <Oladdress></Oladdress>
          {
            <Image
              alt={"加入我们"}
              src={locals() === "zh-CN" ? outlookcn : outlookhk}
              preview={false}
            />
          }
          {/* <div className='line'/> */}
          {location.state.title ? (
            <div className="details-title details-title-size">
              {location.state.title}
            </div>
          ) : null}
          {!location.state.bottom ? (
            <>
              <div dangerouslySetInnerHTML={{ __html: detailsContent }}></div>
              <div className="details-placeholder" />
            </>
          ) : null}
          {/* {console.log(detailsContent)} */}
          {detailsImgs.map((item, index) => {
            return (
              <Image
                src={yjPc}
                alt={item.name + ""}
                preview={false}
                key={index}
                width={"100%"}
              />
            );
          })}

          {location.state.bottom ? (
            <>
              <div className="details-placeholder" />

              {detailsContent_m ? (
                <>
                  <div
                    className="details-pc"
                    dangerouslySetInnerHTML={{ __html: detailsContent }}
                  ></div>
                  <div
                    className="details-phone"
                    dangerouslySetInnerHTML={{ __html: detailsContent_m }}
                  ></div>
                </>
              ) : (
                <div
                  className="details-pc"
                  dangerouslySetInnerHTML={{ __html: detailsContent }}
                ></div>
              )}
            </>
          ) : null}
        </div>
      );
    }
  };
  return <div className="details details-width">{content()}</div>;
};

export default Outlook;
